
import Vue, { VNode } from 'vue';

import {
  autoLink,
  renderAvatar,
  renderDate,
  renderHTML,
  renderLabel,
  renderLink,
  renderValue,
} from '@/components/section-preview/utils/renderer';
import { validatorInArray } from '@/utils/string';

export default Vue.extend({
  props: {
    instance: { type: Object, required: true },
    fieldName: { type: String, required: true },
    label: { type: String, default: null },
    faIcon: { type: String, default: null },
    type: {
      type: String,
      default: 'text',
      validator: validatorInArray([
        'text',
        'date',
        'html',
        'link',
        'snsLink',
        'image',
      ]),
    },
    imageSize: { type: Number, default: null },
    wrapper: { type: String, default: 'div' },
    wrapperClass: { type: String, default: '' },
    valueCallback: { type: Function, default: null },
  },
  computed: {
    wrapperClasses(): string[] {
      const baseHtmlClass = `cv-preview-${this.wrapperClass}`;
      return [baseHtmlClass, `${baseHtmlClass}-${this.fieldName}`];
    },
  },
  render(h) {
    const $label = this.label ? renderLabel(h, this.label, this.faIcon) : null;
    let $value: VNode = null;

    if (this.type === 'image') {
      const value = this.instance[this.fieldName];
      // render empty if nothing
      if (!value) return h('span');
      const url = value?.mid?.url || value?.url;
      const urlOpt = value?.lg?.url || value?.url;
      $value = renderValue(h, this.wrapper, [
        renderAvatar(h, url, {
          width: this.imageSize,
          height: this.imageSize,
          klass: 'SectionPreviewField__Image',
        }),
        renderAvatar(h, urlOpt, {
          width: this.imageSize,
          height: this.imageSize,
          klass: 'SectionPreviewField__ImageOpt',
        }),
      ]);
    } else if (this.type === 'html') {
      const value = this.instance[this.fieldName];
      // render empty if nothing
      if (!value) return h('span');
      $value = renderValue(h, this.wrapper, renderHTML(value), null, true);
    } else if (this.type === 'date') {
      const value = renderDate(h, {
        year: this.instance[`${this.fieldName}_year`],
        month: this.instance[`${this.fieldName}_month`],
        day: this.instance[`${this.fieldName}_day`],
      });
      // render empty if nothing
      if (value.length === 0) return h('span');
      $value = renderValue(h, this.wrapper, value);
    } else if (this.type === 'snsLink') {
      const value = this.instance[this.fieldName];
      // render empty if nothing
      if (!value) return h('span');
      $value = renderValue(h, this.wrapper, renderLink(h, value));
    } else if (this.type === 'link') {
      const value = this.instance[this.fieldName];
      // render empty if nothing
      if (!value) return h('span');
      $value = renderValue(h, this.wrapper, [autoLink(h, value)]);
    } else {
      let value = this.instance[this.fieldName];
      // callback
      if (this.valueCallback) value = this.valueCallback(value);
      // render empty if nothing
      if (!value) return h('span');
      $value = renderValue(h, this.wrapper, value);
    }

    return h('div', { class: this.wrapperClasses }, [$label, $value]);
  },
});
